import { FaCheckCircle, FaUsers, FaLightbulb, FaRocket, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const About = () => {
  const features = [
    {
      icon: FaUsers,
      title: 'Internal Networking',
      description: 'Leverage agile frameworks to provide a robust synopsis for high level overviews.'
    },
    {
      icon: FaLightbulb,
      title: 'Tech Services',
      description: 'Organically grow the holistic world view of disruptive innovation via workplace.'
    }
  ];

  return (
    <section id="about" className="section-padding bg-white relative overflow-hidden font-opensans">
      {/* Background Pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-20 w-96 h-96 border border-gray-100 rounded-full opacity-30 animate-spin-slow"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 border border-gray-100 rounded-full opacity-30 animate-reverse-spin"></div>
        
         {/* Floating Plus Icons */}
         {[...Array(6)].map((_, i) => (
            <motion.div
                key={i}
                className="absolute text-[#22446b] text-4xl font-bold select-none"
                initial={{ opacity: 0.2, scale: 0.5 }}
                animate={{ 
                    y: [0, -20, 0],
                    opacity: [0.2, 0.5, 0.2],
                }}
                transition={{ 
                    duration: 3 + i, 
                    repeat: Infinity,
                    delay: i * 0.5
                }}
                style={{
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                }}
            >
                +
            </motion.div>
        ))}
      </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
             {/* Visual Side */}
             <div className="space-y-8 order-2 lg:order-1 relative">
            {/* Main Image Placeholder */}
            <div className="relative">
              <div className="w-full h-[500px]   rounded-[40px] flex items-center justify-center border-4 border-white shadow-2xl relative overflow-hidden group">
                <div className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/1143773002/photo/business-executive-multi-tasking-around-his-office-cubicle.jpg?s=612x612&w=0&k=20&c=aM36x8Szg6ta9gBSC2qzAyzepWG5s8Zl5aTdLnkhyzk=')] bg-cover bg-center  transition-all duration-700 opacity-90"></div>
                <div className=" "></div>
                
                {/* Floating Experience Badge */}
                <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full flex flex-col items-center justify-center shadow-xl border-4 border-white animate-bounce-slow z-20">
                     <span className="text-4xl font-rajdhani font-bold text-[#22446b]">8+</span>
                     <span className="text-xs uppercase font-bold text-gray-500 mt-1">Years Exp</span>
                </div>
              </div>
              
              {/* Back decorative shape */}
              <div className="absolute -bottom-10 -right-10 w-full h-full bg-gray-100 rounded-[40px] -z-10 transform rotate-3"></div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-8 order-1 lg:order-2">
             {/* Section Header */}
            <div className="text-left">
                <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-[#22446b] to-[#338edc] border border-white/20 rounded-full text-white text-sm font-bold uppercase tracking-wider mb-4">
                    <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
                    Who We Are
                </div>
                <h2 className="text-4xl lg:text-5xl font-rajdhani font-bold text-[#22446b] mb-6 leading-tight">
                    We provide perfect <span className="text-transparent bg-clip-text bg-[#22446b]">IT solutions</span> & technology for any startups
                </h2>
                <p className="text-lg text-[#22446b] leading-relaxed mb-6 font-opensans">
                    Bring to the table win-win survival strategies to ensure proactive domination. 
                    At the end of the day, going forward, a new normal that has evolved from operational X is on the runway.
                </p>
                
                {/* Features List */}
                <div className="space-y-6">
                    {features.map((feature, index) => (
                        <div key={index} className="flex items-start space-x-4 p-4 rounded-xl bg-gradient-to-r from-[#22446b] to-[#338edc] hover:bg-none hover:bg-white hover:shadow-lg transition-all duration-300 border border-transparent hover:border-[#22446b] group">
                            <div className="w-12 h-12 bg-white/20 group-hover:bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors duration-300">
                                <feature.icon className="text-white group-hover:text-[#22446b] text-xl transition-colors" />
                            </div>
                            <div>
                                <h4 className="font-bold font-rajdhani text-white group-hover:text-[#22446b] text-xl mb-2 transition-colors">{feature.title}</h4>
                                <p className="text-white group-hover:text-[#22446b] text-sm leading-relaxed transition-colors">{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA Button */}
                {/* <div className="pt-8">
                    <button className="inline-flex items-center bg-gradient-to-r from-black to-gray-800 text-white font-rajdhani font-bold py-4 px-10 rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl hover:bg-gray-900 hover:-translate-y-1">
                        Discover More
                        <FaArrowRight className="ml-2" />
                    </button>
                </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;